"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BlockLibraryExplainer = void 0;
var kaleidoscope_1 = require("@qwilr/kaleidoscope");
var kaleidoscope_2 = require("@qwilr/kaleidoscope");
var react_1 = __importDefault(require("react"));
var react_transition_group_1 = require("react-transition-group");
var BlockLibraryExplainer = function (_a) {
    var show = _a.show, onDismiss = _a.onDismiss, onExit = _a.onExit, onExited = _a.onExited;
    return (react_1.default.createElement(react_transition_group_1.CSSTransition, { unmountOnExit: true, in: show, timeout: { enter: 0, exit: kaleidoscope_2.AnimationDuration.Short }, classNames: "block-library-explainer-", onExit: onExit, onExited: onExited },
        react_1.default.createElement(kaleidoscope_1.Alert, { heading: "Build faster with drag & drop", theme: kaleidoscope_1.AlertTheme.Dark, onDismiss: onDismiss, className: "block-library-explainer" }, "Click & drag saved blocks from your Library to drop them into your page and add content easily.")));
};
exports.BlockLibraryExplainer = BlockLibraryExplainer;
